import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/common/qr-code.png';
const _withScopeId = n => (_pushScopeId("data-v-14076ae6"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "footer"
};
const _hoisted_2 = {
  class: "about"
};
const _hoisted_3 = {
  class: "about-w"
};
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"info\" data-v-14076ae6><div class=\"title\" data-v-14076ae6>卡奥斯工业互联网平台</div><div class=\"phone\" data-v-14076ae6>400-135-7277</div><div class=\"info-item\" data-v-14076ae6>客服在线时间：9:00-17:30</div><div class=\"info-item\" data-v-14076ae6>Email：support@cosmoplat.com</div><img src=\"" + _imports_0 + "\" class=\"qrcode\" data-v-14076ae6><div class=\"info-item\" data-v-14076ae6>欢迎关注卡奥斯公众号</div></div>", 1);
const _hoisted_5 = {
  class: "title"
};
const _hoisted_6 = ["onClick"];
const _hoisted_7 = {
  class: "bottom"
};
const _hoisted_8 = {
  class: "bottom-w"
};
const _hoisted_9 = {
  class: "info"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "name"
}, "增值电信业务经营许可证：", -1));
const _hoisted_11 = ["onClick"];
const _hoisted_12 = {
  class: "link"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.link, (a, aIndex) => {
    return _openBlock(), _createElementBlock("div", {
      key: aIndex,
      class: _normalizeClass(["link", {
        flex1: !aIndex
      }])
    }, [_createElementVNode("div", _hoisted_5, _toDisplayString(a.title), 1), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(a.children, b => {
      return _openBlock(), _createElementBlock("div", {
        key: b.url,
        class: "link-item"
      }, [_createElementVNode("div", {
        class: "item",
        onClick: $event => $options.handleGo(b.url)
      }, _toDisplayString(b.name), 9, _hoisted_6)]);
    }), 128))], 2);
  }), 128))])]), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createTextVNode(" Copyright ©海尔数字科技（青岛）有限公司版权所有 "), _hoisted_10, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.bottomLink, (item, index) => {
    return _openBlock(), _createElementBlock("span", {
      key: index,
      onClick: $event => $options.handleGo(item.url)
    }, _toDisplayString(item.name), 9, _hoisted_11);
  }), 128))]), _createElementVNode("div", _hoisted_12, [_createElementVNode("span", {
    onClick: _cache[0] || (_cache[0] = $event => $options.handleGo('https://sec.cosmoplat.com/api/agreement/service/1641867039600051'))
  }, "用户服务协议"), _createTextVNode(" ｜ "), _createElementVNode("span", {
    onClick: _cache[1] || (_cache[1] = $event => $options.handleGo('https://sec.cosmoplat.com/api/agreement/private/1641867039600051'))
  }, "隐私政策")])])])]);
}